<template>
  <div>
    <div v-if="quoteWasNotFound" class="pb-3">
      <v-alert type="error" text>
        {{ $t('quote.hint.notFound') }}
      </v-alert>
    </div>

    <div v-if="isQuoteAlreadyPaid || isQuotePaid" class="pb-3">
      <v-alert type="success" text>
        {{ $t('quote.hint.alreadyPaid') }}
      </v-alert>
    </div>

    <div v-if="isOverdue" class="pb-3">
      <v-alert type="warning" text>
        {{ $t('quote.hint.overdue') }}
      </v-alert>
    </div>

    <div v-if="isQuotePending && isNotCreditCard" class="pb-3">
      <v-alert type="warning" text>
        <div class="d-flex align-center">
          {{ $t('quote.hint.awaitingPayment') }}
          <v-spacer class="mx-2" />
          <v-btn
            @click="$parent.handleOpenModalWithPixPaymentSelected()"
            color="warning"
            elevation="0"
            small
          >
            <v-icon left>
              mdi-qrcode
            </v-icon>
            <span class="body-2">
              {{ $t('quote.label.displayQRCode') }}
            </span>
          </v-btn>
        </div>
      </v-alert>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'QuoteMessages',

  props: {
    quoteWasNotFound: {
      type: Boolean,
    },

    isQuoteAlreadyPaid: {
      type: Boolean,
    },

    isQuotePending: {
      type: Boolean,
    },

    isOverdue: {
      type: Boolean,
    },

    paymentMethod: {
      type: String,
    },
  },

  computed: {
    ...mapGetters(['isQuotePaid']),

    isNotCreditCard() {
      return this.paymentMethod !== 'ASAAS_CREDIT_CARD'
    }
  }
}
</script>
